import React, { useState } from "react";

export default function FAQSection({ faqs = [] }) {
  const [openIdx, setOpenIdx] = useState(0);

  if (!faqs || faqs.length === 0) return null;

  const toggle = (idx) => {
    setOpenIdx((prev) => (prev === idx ? -1 : idx));
  };

  return (
    <section className="py-16 sm:py-20 bg-[#F4EFE6]/70 border-y border-[#E2D8C7]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold text-[#12281D] tracking-tight">
            FAQ - Ofte stillede spørgsmål
          </h2>
          <p className="mt-2 text-sm sm:text-base text-[#526D5F]">
            Find svar på de mest almindelige spørgsmål om fældning, beskæring og sikkerhed
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, idx) => {
            const isOpen = openIdx === idx;
            return (
              <div
                key={idx}
                className={`rounded-2xl border transition-all duration-200 overflow-hidden bg-white shadow-sm ${
                  isOpen
                    ? "border-[#1E4231] shadow-md ring-1 ring-[#1E4231]/10"
                    : "border-[#DFD6C7] hover:border-[#1E4231]/50"
                }`}
              >
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  aria-expanded={isOpen}
                  className="w-full text-left p-5 sm:p-6 flex items-center justify-between gap-4 cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D9691E]"
                >
                  <span className="font-bold text-[#14291E] text-base sm:text-lg">
                    {faq.question}
                  </span>
                  <span
                    className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-transform duration-200 ${
                      isOpen
                        ? "bg-[#1E4231] text-white rotate-180"
                        : "bg-[#F4EFE6] text-[#1E4231]"
                    }`}
                  >
                    <i className="fa-solid fa-chevron-down text-xs" aria-hidden="true" />
                  </span>
                </button>

                {isOpen && (
                  <div className="px-5 sm:px-6 pb-6 pt-1 text-[#3B5446] text-sm sm:text-base leading-relaxed border-t border-[#F2ECE1]">
                    <div
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                      className="prose prose-sm max-w-none text-[#334D3F] space-y-2 [&>p]:mb-2 [&>p:last-child]:mb-0 [&_strong]:text-[#14291E]"
                    />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
